import { SVGProps } from 'react';

const DoorOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 20H2m17 0-6.758 1.689a1 1 0 0 1-1.242-.97V4.562a2.004 2.004 0 0 1 1.585-1.956 2 2 0 0 1 .9.016l4 1A2 2 0 0 1 19 5.562zm0 0h3M11 4H8a2 2 0 0 0-2 2v14m8-8h.01"
    />
  </svg>
);
export default DoorOpen;
